import React, { useEffect, useState } from 'react'
import {fetchBrands} from 'authActions.js'
import { getIWGgamesList } from 'integrationActions.js';
import InstantWinGameCard from 'InstantWinGameCard.js';
import S from 'StyledInstantWinGamesList.js';
import { translation } from 'utilsHelper';
import { isConfigDisabledAndNotLocal,processCustomDataProperties } from 'editec/brandsDataHelper.js';
import { useDispatch, connect } from 'react-redux';


const InstantWinGamesList = ({isLogged, user}) => {
    const dispatch = useDispatch()
    const [gamesList, setGamesList] = useState([]);
    const [isCustomerLoggedInWithBalance, updateCustomerLoggedInWithBalance] = useState(false);
    const getBrands = async () => {
        try {
            const brandsData = await dispatch(fetchBrands());
            const countryCode = Cookies.get('countryCode');
            const currentBrand = Object.values(brandsData).find(
                (brand) => brand.countryCode === countryCode
            );
            processCustomDataProperties(currentBrand);
    
            if (isConfigDisabledAndNotLocal("INSTANT_GAMES_ENABLED")) {
                app.router.redirect('/');
            }
        } catch (error) {
            console.error("Error fetching brands:", error);
            app.router.redirect('/');
        }
    };
    useEffect(()=>{
        getBrands()
        fetchIWGgamesList();
        getCustomerLoggedInWithBalance();
    }, [isLogged]) 

    const fetchIWGgamesList = async () => {

        const response = await dispatch(getIWGgamesList());

        setGamesList(response);
    }

    const getCustomerLoggedInWithBalance = () => {

        if (user && user.balance){
            updateCustomerLoggedInWithBalance(true);
        } else {
            updateCustomerLoggedInWithBalance(false);
        }
    }

    const isCustomerUserSession = () => {

        if (user && user.login.indexOf('user_session_') == 0){
            return true;
        }
        return false;
    }

    return (
        <S.InstantWinGameWrapper>

            <S.SessionInfo className={`${isCustomerLoggedInWithBalance ? 'active' : 'inactive'}`}>

                <div className="dot"></div>

                {!isCustomerLoggedInWithBalance ? (
                    <> {translation('instantWinGames_list_notAvailabe')} </>
                ) : (
                    <>
                        {translation('instantWinGames_list_availabe')}  &nbsp;
                        {isCustomerUserSession ? (
                            <div className="sessionUser"> {translation('instantGames_list_availabe_user').replace('{id}', user?.mobileNumber)} </div>
                        ) : null}
                    </>
                )}

            </S.SessionInfo>

            <S.StyledInstantWinGamesList>
                
                {!!gamesList?.length ? (
                    <>
                        {gamesList.map((game, index) => (
                            <InstantWinGameCard key={index} {...{active: isCustomerLoggedInWithBalance, ...game}}></InstantWinGameCard>
                        ))}
                    </>
                ) : (
                    <S.GamesListEmpty> {translation('instantWinGames_list_empty')} </S.GamesListEmpty>
                )}

            </S.StyledInstantWinGamesList>

        </S.InstantWinGameWrapper>
    )
}

const mapStateToProps = ({ Auth: { isLogged, user } }) => {
    return {
        isLogged,
        user
    }
}

export default connect(mapStateToProps)(InstantWinGamesList)